import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import dd from '@/utils/dd.config'

const getUrl = (pathname) => {
  // console.log('process', process.env)
  return window.location.protocol + "//" + window.location.host + `${process.env.NODE_ENV === 'production' ? '/workweb' : ''}/#` + pathname
}

const useHistory = () => {
  const navigate = useNavigate()
  const r = useMemo(
    () => ({
      push: (href, type = 'openLink') => {
        if (type === 'route') {
          navigate(href)
        }else {
          dd.openLink(getUrl(href))
        }
      },
      back: (step = '') => {
        if (step) {
          navigate(-step)
        }else {
          dd.quit()
        }
      }
    }),
    []
  )
  return r
}

export default useHistory
